<input type="checkbox"
        id="a1"
        name="a"
        id="op-c-{{fields.label}}" 
        [checked]="fields.checked === true"
        (change)="checkValidation($event,fields)"
        [disabled]="fields.disabled">
<label for="op-c-{{fields.label}}" [innerHTML]="fields.desc"></label>
<h6 class="mandatory-radio" *ngIf="this.fields.mandatory && fields.checked == false">*Questo campo è obbligatorio per proseguire</h6>
